module.exports = __webpack_public_path__ + "img/image-thumb-1.a284c011.webp";